<template>
  <span class="text-body-1 font-weight-bold text-high-emphasis">
    <slot />
  </span>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SfHeading'
})
</script>
